import { type FC } from 'react';

import { type PartnerInfo } from '@/common/types/userType';
import { UserShortInfo } from '@/components/common/UserShortInfo/UserShortInfo';
import { StringSmall } from '@/components/Typography/Typography';

const PartnerRevenueItem: FC<PartnerInfo> = ({
  name,
  image,
  level,
  earnings,
}) => {
  return (
    <div className="w-full flex py-1 items-center justify-center">
      <UserShortInfo
        className="flex-1 mr-2"
        fullName={name}
        avatarUrl={image}
        level={level}
      />
      <StringSmall weight="bold" className="!text-[14px]">
        {earnings}
      </StringSmall>
    </div>
  );
};

export { PartnerRevenueItem };
